import { render, staticRenderFns } from "./ExceptAreaAddPage.vue?vue&type=template&id=be4d1932&scoped=true&"
import script from "./ExceptAreaAddPage.vue?vue&type=script&lang=js&"
export * from "./ExceptAreaAddPage.vue?vue&type=script&lang=js&"
import style0 from "./ExceptAreaAddPage.vue?vue&type=style&index=0&id=be4d1932&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4d1932",
  null
  
)

export default component.exports